import React, { useMemo } from 'react'

import { useBMStore } from '../../../../../stores/useBMStore'

import { SummaryWidgetCards } from './components/SummaryWidgetCards'
import { SummaryWidgetWrapper, SummaryWidgetBody } from './SummaryWidget.styled'
import { NormalizedSummaryData } from '../../../../../hooks/api/BMDataTypes'

interface SummaryWidgetProps {
  summary: NormalizedSummaryData
}

export const SummaryWidget: React.FC<SummaryWidgetProps> = ({ summary }) => {
  const chosenDomains = useBMStore((state) => state.chosenDomains)

  const summaryData = useMemo(() => {
    const summaryObj = summary.rawData?.summary

    if (chosenDomains?.length === 1 && summaryObj?.summary) {
      return summaryObj.summary[0] || summaryObj.total || null
    } else {
      return summaryObj?.total || null
    }
  }, [chosenDomains, summary.rawData])
  return (
    <SummaryWidgetWrapper>
      <SummaryWidgetBody>
        <SummaryWidgetCards summaryData={summaryData} />
      </SummaryWidgetBody>
    </SummaryWidgetWrapper>
  )
}
